<div>
  <app-page-breadcrumb pageTitle="Mantenimiento de Clientes" />

  <div
    class="mb-4 flex justify-end rounded-2xl border border-gray-200 bg-white px-4 py-4 dark:border-gray-800 dark:bg-white/[0.03]">
    <button type="button"
      class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600"
      (click)="onCreateClient()">
      + Agregar
    </button>

    <button type="button"
      class="ml-2 inline-flex items-center gap-2 rounded-lg bg-gray-200 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-300"
      (click)="loadClients()" [disabled]="loadingTable">
      {{ loadingTable ? 'Actualizando…' : 'Actualizar' }}
    </button>
  </div>
  <div
    class="min-h-[60vh] rounded-2xl border border-gray-200 bg-white px-3 py-5 dark:border-gray-800 dark:bg-white/[0.03] xl:px-4 xl:py-5">
    <div class="w-full">
      <div class="rounded-2xl border border-gray-200 bg-white pt-4 dark:border-white/[0.05] dark:bg-white/[0.03]">
        <div class="flex flex-col gap-2 px-5 mb-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
          <div>
            <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">
              Listado de clientes
            </h3>
          </div>
          <div class="flex flex-col gap-3 sm:flex-row sm:items-center">
            <form>
              <div class="relative">
                <button class="absolute -translate-y-1/2 left-4 top-1/2" type="button">
                  <svg class="fill-gray-500 dark:fill-gray-400" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M3.04199 9.37381C3.04199 5.87712 5.87735 3.04218 9.37533 3.04218C12.8733 3.04218 15.7087 5.87712 15.7087 9.37381C15.7087 12.8705 12.8733 15.7055 9.37533 15.7055C5.87735 15.7055 3.04199 12.8705 3.04199 9.37381ZM9.37533 1.54218C5.04926 1.54218 1.54199 5.04835 1.54199 9.37381C1.54199 13.6993 5.04926 17.2055 9.37533 17.2055C11.2676 17.2055 13.0032 16.5346 14.3572 15.4178L17.1773 18.2381C17.4702 18.531 17.945 18.5311 18.2379 18.2382C18.5308 17.9453 18.5309 17.4704 18.238 17.1775L15.4182 14.3575C16.5367 13.0035 17.2087 11.2671 17.2087 9.37381C17.2087 5.04835 13.7014 1.54218 9.37533 1.54218Z"
                      fill=""></path>
                  </svg>
                </button>
                <input type="text" placeholder="Buscar..." (input)="setSearchTerm($any($event.target).value)"
                  class="dark:bg-dark-900 h-[42px] w-full rounded-lg border border-gray-300 bg-transparent py-2.5 pl-[42px] pr-4 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 xl:w-[300px]" />
              </div>
            </form>
          </div>
        </div>

        <div class="overflow-hidden">
          <div class="max-w-full px-5 overflow-x-auto sm:px-6">
            <table class="w-full min-w-full">
              <thead class="border-gray-100 border-y dark:border-white/[0.05]">
                <tr>
                  <th class="w-[30%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                    <button class="inline-flex items-center gap-1 hover:text-gray-700 dark:hover:text-gray-200"
                      (click)="toggleSort('nombre')">
                      Nombres / Razón Social
                      <svg class="w-3.5 h-3.5" [class.text-brand-500]="sortColumn === 'nombre'" fill="none"
                        stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                        @if (sortColumn === 'nombre' && sortDir === 'asc') {
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" />
                        } @else if (sortColumn === 'nombre' && sortDir === 'desc') {
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                        } @else {
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4" />
                        }
                      </svg>
                    </button>
                  </th>
                  <th class="w-[16%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                    Documento
                  </th>
                  <th class="w-[14%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                    Teléfono
                  </th>
                  <th class="w-[16%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                    Correo
                  </th>
                  <th class="w-[12%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                    Estado
                  </th>
                  <th class="w-[12%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
                @if (loading) {
                <tr>
                  <td class="py-4 text-center text-gray-700 text-theme-sm dark:text-gray-400" colspan="6">
                    Cargando...
                  </td>
                </tr>
                } @else {
                @if (currentItems.length === 0) {
                <tr>
                  <td class="py-4 text-center text-gray-700 text-theme-sm dark:text-gray-400" colspan="6">
                    No hay datos disponibles.
                  </td>
                </tr>
                } @else {
                @for (item of currentItems; track $index) {
                <tr>
                  <td class="py-2">
                    <div class="flex items-center gap-3">
                      <span class="block font-medium text-gray-700 text-theme-sm dark:text-gray-400">
                        {{ item.firstName ? item.firstName + ' ' + item.lastName : item.businessName }}
                      </span>
                    </div>
                  </td>
                  <td class="py-2 text-gray-700 whitespace-nowrap text-theme-sm dark:text-gray-400">
                    {{ item.documentType + ' ' + item.documentNumber }}
                  </td>
                  <td class="py-2 text-gray-700 text-theme-sm dark:text-gray-400">
                    {{ item.phone1 ? item.phone1 : '-' }}
                  </td>
                  <td class="py-2 text-gray-700 text-theme-sm dark:text-gray-400">
                    {{ item.email1 ? item.email1 : '-' }}
                  </td>
                  <td class="py-2 text-gray-700 text-theme-sm dark:text-gray-400">
                    <app-badge size="sm" [color]="getBadgeColor(item.status)">
                      {{ getBadgeText(item.status) }}
                    </app-badge>
                  </td>
                  <td class="py-2 text-gray-700 text-theme-sm dark:text-gray-400">
                    <div>
                      <div class="shadow-theme-xs inline-flex items-center gap-1.5">
                        <button type="button"
                          class="bg-orange-300 hover:bg-orange-400 inline-flex items-center gap-2 px-2.5 py-2 text-sm font-medium text-white rounded-md"
                          (click)="onEditClient(item)">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M20.8749 2.51272C20.1915 1.8293 19.0835 1.8293 18.4001 2.51272L13.2418 7.67095C12.879 8.03379 12.6511 8.50974 12.5959 9.0199L12.4069 10.7668C12.3824 10.9926 12.4616 11.2173 12.6222 11.3778C12.7827 11.5384 13.0074 11.6176 13.2332 11.5931L14.9801 11.4041C15.4903 11.3489 15.9662 11.121 16.3291 10.7582L21.4873 5.59994C22.1707 4.91652 22.1707 3.80848 21.4873 3.12506L20.8749 2.51272ZM18.5981 4.43601L19.564 5.40191L15.2684 9.69751C15.1474 9.81846 14.9888 9.89443 14.8187 9.91283L13.9984 10.0016L14.0872 9.18126C14.1056 9.01121 14.1815 8.85256 14.3025 8.73161L18.5981 4.43601Z"
                              fill="#323544" />
                            <path
                              d="M5.5 3.25H15.5411L14.0411 4.75H5.5C5.08579 4.75 4.75 5.08579 4.75 5.5V18.5C4.75 18.9142 5.08579 19.25 5.5 19.25H18.5C18.9142 19.25 19.25 18.9142 19.25 18.5V9.95823L20.75 8.45823V18.5C20.75 19.7426 19.7426 20.75 18.5 20.75H5.5C4.25736 20.75 3.25 19.7426 3.25 18.5V5.5C3.25 4.25736 4.25736 3.25 5.5 3.25Z"
                              fill="#323544" />
                          </svg>
                        </button>
                        <button type="button"
                          class="inline-flex items-center gap-2 px-2.5 py-2 text-sm font-medium text-white rounded-md"
                          [ngClass]="
                                  item.status === 1
                                    ? 'bg-red-300 hover:bg-red-400'
                                    : 'bg-green-300 hover:bg-green-400'
                                " (click)="openToggleConfirm(item)" [attr.title]="
                                  item.status === 1 ? 'Inactivar' : 'Activar'
                                ">
                          @if (item.status === 1) {
                          <!-- icono inactivar (basurero / deshabilitar) -->
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M14.7223 12.7585C14.7426 12.3448 14.4237 11.9929 14.01 11.9726C13.5963 11.9522 13.2444 12.2711 13.2241 12.6848L12.9999 17.2415C12.9796 17.6552 13.2985 18.0071 13.7122 18.0274C14.1259 18.0478 14.4778 17.7289 14.4981 17.3152L14.7223 12.7585Z"
                              fill="#323544" />
                            <path
                              d="M9.98802 11.9726C9.5743 11.9929 9.25542 12.3448 9.27577 12.7585L9.49993 17.3152C9.52028 17.7289 9.87216 18.0478 10.2859 18.0274C10.6996 18.0071 11.0185 17.6552 10.9981 17.2415L10.774 12.6848C10.7536 12.2711 10.4017 11.9522 9.98802 11.9726Z"
                              fill="#323544" />
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M10.249 2C9.00638 2 7.99902 3.00736 7.99902 4.25V5H5.5C4.25736 5 3.25 6.00736 3.25 7.25C3.25 8.28958 3.95503 9.16449 4.91303 9.42267L5.54076 19.8848C5.61205 21.0729 6.59642 22 7.78672 22H16.2113C17.4016 22 18.386 21.0729 18.4573 19.8848L19.085 9.42267C20.043 9.16449 20.748 8.28958 20.748 7.25C20.748 6.00736 19.7407 5 18.498 5H15.999V4.25C15.999 3.00736 14.9917 2 13.749 2H10.249ZM14.499 5V4.25C14.499 3.83579 14.1632 3.5 13.749 3.5H10.249C9.83481 3.5 9.49902 3.83579 9.49902 4.25V5H14.499ZM5.5 6.5C5.08579 6.5 4.75 6.83579 4.75 7.25C4.75 7.66421 5.08579 8 5.5 8H18.498C18.9123 8 19.248 7.66421 19.248 7.25C19.248 6.83579 18.9123 6.5 18.498 6.5H5.5ZM6.42037 9.5H17.5777L16.96 19.7949C16.9362 20.191 16.6081 20.5 16.2113 20.5H7.78672C7.38995 20.5 7.06183 20.191 7.03807 19.7949L6.42037 9.5Z"
                              fill="#323544" />
                          </svg>
                          } @else {
                          <!-- icono activar (check) -->
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M20.285 6.709a1 1 0 0 1 .006 1.414l-9.2 9.3a1 1 0 0 1-1.42-.002L3.71 11.46a1 1 0 1 1 1.414-1.414l4.06 4.06 8.49-8.58a1 1 0 0 1 1.41.183Z"
                              fill="#323544" />
                          </svg>
                          }
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
                }
                }
                }
              </tbody>
            </table>
          </div>
        </div>

        <!-- Pagination Controls -->
        <div class="px-6 py-4 border-t border-gray-200 dark:border-white/[0.05]">
          <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div class="flex items-center gap-2">
              <span class="text-sm text-gray-500 dark:text-gray-400">Mostrar</span>
              <select
                class="h-9 rounded-lg border border-gray-300 bg-white px-2 text-sm text-gray-700 focus:border-brand-300 focus:outline-none dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300"
                (change)="onPageSizeChange(+$any($event.target).value)">
                @for (opt of pageSizeOptions; track opt) {
                <option [value]="opt" [selected]="opt === itemsPerPage">{{ opt }}</option>
                }
              </select>
              <span class="text-sm text-gray-500 dark:text-gray-400">registros</span>
            </div>
            <div class="flex items-center justify-between sm:justify-end gap-2">
              <app-button size="sm" variant="outline" (btnClick)="goToPage(currentPage - 1)"
                [disabled]="currentPage === 1">
                <svg class="fill-current" width="20" height="20" viewBox="0 0 20 20" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M2.58301 9.99868C2.58272 10.1909 2.65588 10.3833 2.80249 10.53L7.79915 15.5301C8.09194 15.8231 8.56682 15.8233 8.85981 15.5305C9.15281 15.2377 9.15297 14.7629 8.86018 14.4699L5.14009 10.7472L16.6675 10.7472C17.0817 10.7472 17.4175 10.4114 17.4175 9.99715C17.4175 9.58294 17.0817 9.24715 16.6675 9.24715L5.14554 9.24715L8.86017 5.53016C9.15297 5.23717 9.15282 4.7623 8.85983 4.4695C8.56684 4.1767 8.09197 4.17685 7.79917 4.46984L2.84167 9.43049C2.68321 9.568 2.58301 9.77087 2.58301 9.99715C2.58301 9.99766 2.58301 9.99817 2.58301 9.99868Z"
                    fill=""></path>
                </svg>
                <span class="hidden sm:inline">Anterior</span>
              </app-button>
              <span class="block text-sm font-medium text-gray-700 dark:text-gray-400 sm:hidden">
                Pág. {{ currentPage }} / {{ totalPages }}
              </span>
              <ul class="hidden items-center gap-0.5 sm:flex">
                @for (item of pageItems; track $index) {
                <li>
                  @if (item === '...') {
                  <span class="flex h-10 w-8 items-center justify-center text-sm text-gray-400 select-none">…</span>
                  } @else {
                  <button (click)="goToPage(item)"
                    class="flex h-10 w-10 items-center justify-center rounded-lg text-theme-sm font-medium" [ngClass]="{
                      'bg-brand-500 text-white': currentPage === item,
                      'text-gray-700 hover:bg-brand-500/8 dark:hover:bg-brand-500 dark:hover:text-white hover:text-brand-500 dark:text-gray-400': currentPage !== item
                    }">
                    {{ item }}
                  </button>
                  }
                </li>
                }
              </ul>
              <app-button (btnClick)="goToPage(currentPage + 1)" size="sm" variant="outline"
                [disabled]="currentPage === totalPages">
                <span class="hidden sm:inline">Siguiente</span>
                <svg class="fill-current" width="20" height="20" viewBox="0 0 20 20" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M17.4175 9.9986C17.4178 10.1909 17.3446 10.3832 17.198 10.53L12.2013 15.5301C11.9085 15.8231 11.4337 15.8233 11.1407 15.5305C10.8477 15.2377 10.8475 14.7629 11.1403 14.4699L14.8604 10.7472L3.33301 10.7472C2.91879 10.7472 2.58301 10.4114 2.58301 9.99715C2.58301 9.58294 2.91879 9.24715 3.33301 9.24715L14.8549 9.24715L11.1403 5.53016C10.8475 5.23717 10.8477 4.7623 11.1407 4.4695C11.4336 4.1767 11.9085 4.17685 12.2013 4.46984L17.1588 9.43049C17.3173 9.568 17.4175 9.77087 17.4175 9.99715C17.4175 9.99763 17.4175 9.99812 17.4175 9.9986Z"
                    fill=""></path>
                </svg>
              </app-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-modal [isOpen]="showForm" [className]="'max-w-3xl p-6 sm:p-8'" (close)="onCloseForm()">
  <div class="mb-5">
    <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">
      {{ isEditMode ? "Editar cliente" : "Registrar cliente" }}
    </h3>
    <p class="text-sm text-gray-500 dark:text-gray-400">
      Completa los datos del cliente y guarda los cambios.
    </p>
  </div>

  <form (ngSubmit)="onSubmitClient()">
    <div class="space-y-5">
      <div class="grid grid-cols-1 gap-5 sm:grid-cols-12">
        <!-- PERSON TYPE -->
        <div class="sm:col-span-4">
          <app-label>Tipo de persona <span class="text-error-500">*</span></app-label>
          <app-select [options]="personTypeOptions" placeholder="Seleccione tipo de persona" [(value)]="personTypeId"
            (valueChange)="onPersonTypeChange($event)"></app-select>
          @if (submittedClient && !personTypeId) {
          <p class="mt-1 text-sm text-error-500">
            El tipo de persona es obligatorio
          </p>
          }
        </div>

        <!-- DOCUMENT TYPE -->
        <div class="sm:col-span-4">
          <app-label>Tipo de documento <span class="text-error-500">*</span></app-label>
          <app-select [options]="documentTypeOptions" [(value)]="documentTypeId" placeholder="Seleccione tipo de doc."
            [loading]="loadingDocumentTypes" loadingText="Cargando..." [disabled]="disabledDocumentType"></app-select>
          @if (submittedClient && !documentTypeId) {
          <p class="mt-1 text-sm text-error-500">
            El tipo de documento es obligatorio
          </p>
          }
        </div>
        <!-- DOCUMENT NUMBER -->
        <div class="sm:col-span-4">
          <app-label>Número de documento <span class="text-error-500">*</span></app-label>
          <div class="flex">
            <input type="text" [(ngModel)]="documentNumber" name="documentNumber"
              placeholder="Ingrese número de documento"
              class="h-11 w-full min-w-0 rounded-l-lg border border-r-0 border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30" />
            <button type="button" [disabled]="!canLookup || isLookingUp" (click)="lookupDocument()"
              title="Consultar documento"
              class="flex h-11 items-center justify-center rounded-r-lg border border-gray-300 bg-gray-50 px-3 text-gray-500 transition-colors hover:bg-gray-100 hover:text-brand-600 disabled:cursor-not-allowed disabled:opacity-40 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700">
              @if (isLookingUp) {
              <svg class="h-4 w-4 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
              </svg>
              } @else {
              <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <circle cx="11" cy="11" r="8" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-4.35-4.35" />
              </svg>
              }
            </button>
          </div>
          @if (submittedClient && !documentNumber) {
          <p class="mt-1 text-sm text-error-500">El número de documento es obligatorio</p>
          }
        </div>
      </div>

      <!-- AGENTE DE RETENCIÓN -->
      <div>
        <app-checkbox label="Agente de retención" [checked]="isLegalPersonSelected && retentionAgent" [disabled]="!isLegalPersonSelected"
          (checkedChange)="retentionAgent = $event"></app-checkbox>
        @if (!isLegalPersonSelected) {
        <p class="mt-1 text-xs text-gray-400 dark:text-gray-500">Solo aplica para personas jurídicas.</p>
        }
      </div>

      <!-- NATURAL PERSON -->
      @if (isNaturalPerson()) {
      <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <div>
          <app-label>Nombres <span class="text-error-500">*</span></app-label>
          <app-input-field [(value)]="firstName" name="firstName" placeholder="Ingrese nombres" />
          @if (submittedClient && !firstName) {
          <p class="mt-1 text-sm text-error-500">
            Los nombres son obligatorios
          </p>
          }
        </div>

        <div>
          <app-label>Apellidos <span class="text-error-500">*</span></app-label>
          <app-input-field [(value)]="lastName" name="lastName" placeholder="Ingrese apellidos" />
          @if (submittedClient && !lastName) {
          <p class="mt-1 text-sm text-error-500">
            Los apellidos son obligatorios
          </p>
          }
        </div>
      </div>
      }

      <!-- LEGAL PERSON -->
      @if (isLegalPerson()) {
      <div class="grid grid-cols-1 gap-5 sm:grid-cols-12">
        <div class="sm:col-span-8">
          <app-label>Razón social <span class="text-error-500">*</span></app-label>
          <app-input-field [(value)]="businessName" name="businessName" placeholder="Ingrese razón social" />
          @if (submittedClient && !businessName) {
          <p class="mt-1 text-sm text-error-500">
            La razón social es obligatoria
          </p>
          }
        </div>

        <div class="sm:col-span-4">
          <app-label>Contacto</app-label>
          <app-input-field [(value)]="contactPersonName" name="contactPersonName" placeholder="Nombre de contacto" />
        </div>
      </div>
      }

      <!-- CONTACT -->
      <div class="grid grid-cols-1 gap-5 sm:grid-cols-12">
        @if (isNaturalPerson()) {<div class="sm:col-span-4">
          <app-label>Fecha de nacimiento</app-label>
          <app-date-picker
            placeholder="Seleccionar fecha"
            [defaultDate]="birthDate || undefined"
            (dateChange)="birthDate = $event.dateStr">
          </app-date-picker>
        </div>
        }

        <div class="sm:col-span-4">
          <app-label>Teléfono 1 <span class="text-error-500">*</span></app-label>
          <div class="flex">
            <app-phone-picker [(value)]="countryCode1" class="w-22.5 shrink-0"></app-phone-picker>
            <input type="text" [(ngModel)]="phone1" name="phone1" placeholder="Ej: 999888777"
              [maxlength]="getPhoneMaxLength(countryCode1)"
              class="h-11 w-full min-w-0 rounded-r-lg border border-l-0 border-gray-300 bg-transparent px-3 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30" />
          </div>
          @if (submittedClient && !phone1) {
          <p class="mt-1 text-sm text-error-500">El teléfono es obligatorio</p>
          } @else if (submittedClient && phone1 && phone1.length !== getPhoneMaxLength(countryCode1)) {
          <p class="mt-1 text-sm text-error-500">Debe tener {{ getPhoneMaxLength(countryCode1) }} dígitos</p>
          }
        </div>

        <div class="sm:col-span-4">
          <app-label>Teléfono 2</app-label>
          <div class="flex">
            <app-phone-picker [(value)]="countryCode2" class="w-22.5 shrink-0"></app-phone-picker>
            <input type="text" [(ngModel)]="phone2" name="phone2" placeholder="Opcional"
              [maxlength]="getPhoneMaxLength(countryCode2)"
              class="h-11 w-full min-w-0 rounded-r-lg border border-l-0 border-gray-300 bg-transparent px-3 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30" />
          </div>
        </div>

        <div [ngClass]="isLegalPerson() ? 'sm:col-span-4' : 'sm:col-span-6'">
          <app-label>Correo 1</app-label>
          <app-input-field [(value)]="email1" name="email1" placeholder="correo@dominio.com" />
        </div>

        <div [ngClass]="isLegalPerson() ? 'sm:col-span-4' : 'sm:col-span-6'">
          <app-label>Correo 2</app-label>
          <app-input-field [(value)]="email2" name="email2" placeholder="Opcional" />
        </div>

      </div>

      <!-- ADDRESSES -->
      <div class="pt-4 border-t border-gray-100 dark:border-gray-800">
        <h4 class="mb-3 text-sm font-semibold text-gray-700 dark:text-gray-300">Direcciones</h4>

        <!-- CREATE MODE: local list -->
        @if (!isEditMode) {
        @if (createAddresses.length > 0) {
        <div class="mb-3 space-y-2">
          @for (a of createAddresses; track $index; let idx = $index) {
          <div class="flex items-center gap-2">
            <div class="flex flex-1 flex-col justify-center rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 dark:border-gray-700 dark:bg-gray-800">
              <span class="text-sm text-gray-700 dark:text-gray-300">{{ a.address }}</span>
              @if (a.ubigeo || a.description) {
              <span class="mt-0.5 text-xs text-gray-400 dark:text-gray-500">
                @if (a.ubigeo) { {{ a.ubigeo }} }
                @if (a.ubigeo && a.description) { · }
                @if (a.description) { {{ a.description }} }
              </span>
              }
            </div>
            <button type="button" (click)="removeCreateAddress(idx)"
              class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-red-300 text-white hover:bg-red-400">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.249 2C9.00638 2 7.99902 3.00736 7.99902 4.25V5H5.5C4.25736 5 3.25 6.00736 3.25 7.25C3.25 8.28958 3.95503 9.16449 4.91303 9.42267L5.54076 19.8848C5.61205 21.0729 6.59642 22 7.78672 22H16.2113C17.4016 22 18.386 21.0729 18.4573 19.8848L19.085 9.42267C20.043 9.16449 20.748 8.28958 20.748 7.25C20.748 6.00736 19.7407 5 18.498 5H15.999V4.25C15.999 3.00736 14.9917 2 13.749 2H10.249ZM14.499 5V4.25C14.499 3.83579 14.1632 3.5 13.749 3.5H10.249C9.83481 3.5 9.49902 3.83579 9.49902 4.25V5H14.499ZM5.5 6.5C5.08579 6.5 4.75 6.83579 4.75 7.25C4.75 7.66421 5.08579 8 5.5 8H18.498C18.9123 8 19.248 7.66421 19.248 7.25C19.248 6.83579 18.9123 6.5 18.498 6.5H5.5ZM6.42037 9.5H17.5777L16.96 19.7949C16.9362 20.191 16.6081 20.5 16.2113 20.5H7.78672C7.38995 20.5 7.06183 20.191 7.03807 19.7949L6.42037 9.5Z" fill="white"/>
              </svg>
            </button>
          </div>
          }
        </div>
        }
        <div class="space-y-2">
          <input type="text" [(ngModel)]="newCreateAddrAddress" name="newCreateAddrAddress"
            placeholder="Dirección (ej. Av. Principal 123)"
            class="h-9 w-full rounded-lg border border-gray-300 bg-transparent px-3 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:text-white/90 dark:placeholder:text-white/30" />
          <div class="flex flex-col gap-2 sm:flex-row sm:items-center">
            <div class="flex-1 min-w-0">
              <app-ubigeo-picker [(value)]="newCreateAddrUbigeo" [ubigeos]="allUbigeos" [loading]="loadingUbigeos"
                placeholder="Ubigeo (opcional)"></app-ubigeo-picker>
            </div>
            <input type="text" [(ngModel)]="newCreateAddrDescription" name="newCreateAddrDescription"
              placeholder="Descripción"
              class="h-9 w-full rounded-lg border border-gray-300 bg-transparent px-3 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:text-white/90 dark:placeholder:text-white/30 sm:w-36" />
            <button type="button" (click)="addCreateAddress()" [disabled]="!newCreateAddrAddress.trim()"
              class="inline-flex h-9 items-center justify-center rounded-lg bg-brand-500 px-3 text-sm text-white hover:bg-brand-600 disabled:opacity-50 whitespace-nowrap">
              Agregar
            </button>
          </div>
        </div>
        }

        <!-- EDIT MODE: sub-resource management -->
        @if (isEditMode) {
        @if (addresses.length > 0) {
        <div class="mb-3 space-y-2">
          @for (a of addresses; track a.id) {
          <div class="flex items-center gap-2">
            @if (editingAddressId === a.id) {
            <!-- Edit row -->
            <div class="flex flex-1 flex-col gap-2">
              <input type="text" [(ngModel)]="editingAddrAddress" name="editAddr_{{ a.id }}"
                placeholder="Dirección *"
                class="h-9 w-full rounded-lg border border-gray-300 bg-transparent px-3 text-sm text-gray-800 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:text-white/90" />
              <div class="flex flex-col gap-2 sm:flex-row sm:items-center">
                <div class="flex-1 min-w-0">
                  <app-ubigeo-picker [(value)]="editingAddrUbigeo" [ubigeos]="allUbigeos" [loading]="loadingUbigeos"
                    placeholder="Ubigeo"></app-ubigeo-picker>
                </div>
                <input type="text" [(ngModel)]="editingAddrDescription" name="editDesc_{{ a.id }}"
                  placeholder="Descripción"
                  class="h-9 w-full rounded-lg border border-gray-300 bg-transparent px-3 text-sm text-gray-800 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:text-white/90 sm:w-32" />
                <button type="button" (click)="saveAddress(a)" [disabled]="isSavingAddr"
                  class="inline-flex h-9 items-center justify-center rounded-lg bg-brand-500 px-3 text-sm text-white hover:bg-brand-600 disabled:opacity-50 whitespace-nowrap">
                  @if (isSavingAddr) { Guardando… } @else { Guardar }
                </button>
                <button type="button" (click)="cancelEditAddress()"
                  class="inline-flex h-9 items-center justify-center rounded-lg border border-gray-300 px-3 text-sm text-gray-600 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 whitespace-nowrap">
                  Cancelar
                </button>
              </div>
            </div>
            } @else {
            <!-- Display row -->
            <div class="flex flex-1 flex-col justify-center rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 dark:border-gray-700 dark:bg-gray-800">
              <span class="text-sm text-gray-700 dark:text-gray-300">{{ a.address }}</span>
              @if (a.ubigeo || a.description) {
              <span class="mt-0.5 text-xs text-gray-400 dark:text-gray-500">
                @if (a.ubigeo) { {{ a.ubigeo }} }
                @if (a.ubigeo && a.description) { · }
                @if (a.description) { {{ a.description }} }
              </span>
              }
            </div>
            <button type="button" (click)="startEditAddress(a)"
              class="inline-flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-orange-300 text-white hover:bg-orange-400">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.8749 2.51272C20.1915 1.8293 19.0835 1.8293 18.4001 2.51272L13.2418 7.67095C12.879 8.03379 12.6511 8.50974 12.5959 9.0199L12.4069 10.7668C12.3824 10.9926 12.4616 11.2173 12.6222 11.3778C12.7827 11.5384 13.0074 11.6176 13.2332 11.5931L14.9801 11.4041C15.4903 11.3489 15.9662 11.121 16.3291 10.7582L21.4873 5.59994C22.1707 4.91652 22.1707 3.80848 21.4873 3.12506L20.8749 2.51272ZM18.5981 4.43601L19.564 5.40191L15.2684 9.69751C15.1474 9.81846 14.9888 9.89443 14.8187 9.91283L13.9984 10.0016L14.0872 9.18126C14.1056 9.01121 14.1815 8.85256 14.3025 8.73161L18.5981 4.43601Z" fill="white"/>
                <path d="M5.5 3.25H15.5411L14.0411 4.75H5.5C5.08579 4.75 4.75 5.08579 4.75 5.5V18.5C4.75 18.9142 5.08579 19.25 5.5 19.25H18.5C18.9142 19.25 19.25 18.9142 19.25 18.5V9.95823L20.75 8.45823V18.5C20.75 19.7426 19.7426 20.75 18.5 20.75H5.5C4.25736 20.75 3.25 19.7426 3.25 18.5V5.5C3.25 4.25736 4.25736 3.25 5.5 3.25Z" fill="white"/>
              </svg>
            </button>
            <button type="button" (click)="openDeleteAddress(a)"
              class="inline-flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-red-300 text-white hover:bg-red-400">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.249 2C9.00638 2 7.99902 3.00736 7.99902 4.25V5H5.5C4.25736 5 3.25 6.00736 3.25 7.25C3.25 8.28958 3.95503 9.16449 4.91303 9.42267L5.54076 19.8848C5.61205 21.0729 6.59642 22 7.78672 22H16.2113C17.4016 22 18.386 21.0729 18.4573 19.8848L19.085 9.42267C20.043 9.16449 20.748 8.28958 20.748 7.25C20.748 6.00736 19.7407 5 18.498 5H15.999V4.25C15.999 3.00736 14.9917 2 13.749 2H10.249ZM14.499 5V4.25C14.499 3.83579 14.1632 3.5 13.749 3.5H10.249C9.83481 3.5 9.49902 3.83579 9.49902 4.25V5H14.499ZM5.5 6.5C5.08579 6.5 4.75 6.83579 4.75 7.25C4.75 7.66421 5.08579 8 5.5 8H18.498C18.9123 8 19.248 7.66421 19.248 7.25C19.248 6.83579 18.9123 6.5 18.498 6.5H5.5ZM6.42037 9.5H17.5777L16.96 19.7949C16.9362 20.191 16.6081 20.5 16.2113 20.5H7.78672C7.38995 20.5 7.06183 20.191 7.03807 19.7949L6.42037 9.5Z" fill="white"/>
              </svg>
            </button>
            }
          </div>
          }
        </div>
        }

        <!-- Add new address -->
        <div class="space-y-2">
          <input type="text" [(ngModel)]="newAddrAddress" name="newAddrAddress"
            placeholder="Nueva dirección (ej. Av. Principal 123)"
            class="h-9 w-full rounded-lg border border-gray-300 bg-transparent px-3 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:text-white/90 dark:placeholder:text-white/30" />
          <div class="flex flex-col gap-2 sm:flex-row sm:items-center">
            <div class="flex-1 min-w-0">
              <app-ubigeo-picker [(value)]="newAddrUbigeo" [ubigeos]="allUbigeos" [loading]="loadingUbigeos"
                placeholder="Ubigeo (opcional)"></app-ubigeo-picker>
            </div>
            <input type="text" [(ngModel)]="newAddrDescription" name="newAddrDescription"
              placeholder="Descripción"
              class="h-9 w-full rounded-lg border border-gray-300 bg-transparent px-3 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:text-white/90 dark:placeholder:text-white/30 sm:w-36" />
            <button type="button" (click)="addAddress()" [disabled]="isAddingAddr || !newAddrAddress.trim()"
              class="inline-flex h-9 items-center justify-center rounded-lg bg-brand-500 px-3 text-sm text-white hover:bg-brand-600 disabled:opacity-50 whitespace-nowrap">
              @if (isAddingAddr) { Agregando… } @else { Agregar dirección }
            </button>
          </div>
        </div>
        }

      </div>

      <!-- ACTIONS -->
      <div class="flex items-center justify-end gap-3 pt-2">
        <button type="button" (click)="onCloseForm()"
          class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
          Cancelar
        </button>

        <button type="submit" [disabled]="isSubmittingClient"
          class="px-4 py-2 text-sm font-medium text-white rounded-lg bg-brand-500 hover:bg-brand-600 disabled:opacity-50">
          {{
            isSubmittingClient
              ? "Guardando…"
              : isEditMode
                ? "Guardar cambios"
                : "Registrar"
          }}
        </button>
      </div>
    </div>
  </form>
</app-modal>

<!-- CONFIRM DELETE ADDRESS -->
<app-modal [isOpen]="showConfirmDeleteAddr" [className]="'max-w-md p-6 sm:p-7'" (close)="closeDeleteAddress()">
  <div class="mb-3">
    <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Eliminar dirección</h3>
    <p class="text-sm text-gray-500 dark:text-gray-400">
      ¿Deseas eliminar la dirección <span class="font-semibold text-gray-700 dark:text-gray-200">{{ deleteAddrTarget?.address }}</span>?
      Esta acción no se puede deshacer.
    </p>
  </div>
  <div class="flex items-center justify-end gap-3 pt-4">
    <button type="button" (click)="closeDeleteAddress()"
      class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
      Cancelar
    </button>
    <button type="button" (click)="confirmDeleteAddress()" [disabled]="isDeletingAddr"
      class="px-4 py-2 text-sm font-medium text-white rounded-lg bg-red-500 hover:bg-red-600 disabled:opacity-50">
      {{ isDeletingAddr ? 'Eliminando...' : 'Eliminar' }}
    </button>
  </div>
</app-modal>

<app-modal [isOpen]="showConfirmToggle" [className]="'max-w-md p-6 sm:p-7'" (close)="closeToggleConfirm()">
  <div class="mb-3">
    <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">
      Confirmar acción
    </h3>
    <p class="text-sm text-gray-500 dark:text-gray-400">
      {{ toggleConfirmText }}
    </p>
  </div>

  <div class="flex items-center justify-end gap-3 pt-4">
    <button type="button" (click)="closeToggleConfirm()"
      class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
      Cancelar
    </button>

    <button type="button" (click)="confirmToggleStatus()" [disabled]="isToggleStatus"
      class="px-4 py-2 text-sm font-medium text-white rounded-lg" [ngClass]="
        toggleTarget?.status === 1
          ? 'bg-red-500 hover:bg-red-600'
          : 'bg-green-500 hover:bg-green-600'
      ">
      {{ isToggleStatus ? 'Procesando...' : toggleActionLabel }}
    </button>
  </div>
</app-modal>